export default {
	async addNewStats(context, payload) {
		const token = localStorage.getItem('token');
		const userId = payload.user.id
		// change this to response data and calculate on response before setting
		const BA = (payload.singles + payload.doubles + payload.triples + payload.homeruns) / payload.atBats
		const SLG = ((payload.singles) + (2 * payload.doubles) + (3 * payload.triples) + (4 * payload.homeruns)) / payload.atBats
		const OBP = (payload.singles + payload.doubles + payload.triples + payload.homeruns + payload.walks + payload.hbp)/(payload.atBats + payload.walks + payload.hbp + payload.sf)
		const stats = {
			userId: userId,
			atBats: payload.atBats,
			walks: payload.walks,
			hbp: payload.hbp,
			sf: payload.sf,
			so: payload.so,
			singles: payload.singles,
			doubles: payload.doubles,
			triples: payload.triples,
			homeruns: payload.homeruns,
			ip: payload.ip,
			hits: payload.hits,
			runs: payload.runs,
			er: payload.er,
			bb: payload.bb,
			k: payload.k,
			hr: payload.hr,

			// BA: payload.BA,
			// SLG: payload.SLG,
			// OBP: payload.OBP
		};
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/users/${userId}/stats.json?auth=` + token,
			{
				method: 'PATCH',
				body: JSON.stringify(stats),
			}
		);
		const responseData = await response.json();
		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed to fetch teams.');
			throw error;
		}

		// localStorage.setItem('userTeam', responseData.team);
		// context.commit('setUserTeam', {
		// 	userTeam: responseData.team,
		// });
	},
	async fetchUserStats(context, payload) {
		const token = localStorage.getItem('token');
		const userId = payload.userId
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/users/${userId}/stats.json?auth=` + token,
			{
				method: 'GET',
			}
		);
		const responseData = await response.json();
		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed to fetch teams.');
			throw error;
		}
		
		context.commit('setUserStats', {
			userId: responseData.userId,
			atBats: responseData.atBats,
			walks: responseData.walks,
			sf: responseData.sf,
			so: responseData.so,
			hbp: responseData.hbp,
			singles: responseData.singles,
			doubles: responseData.doubles,
			triples: responseData.triples,
			homeruns: responseData.homeruns,
			BA: (
				(responseData.singles + responseData.doubles + responseData.triples + responseData.homeruns) /
				responseData.atBats
			)
				.toFixed(3)
				.substring(1),
			SLG: (
				(responseData.singles +
					2 * responseData.doubles +
					3 * responseData.triples +
					4 * responseData.homeruns) /
				responseData.atBats
			)
				.toFixed(3)
				.substring(1),
			OBP: (
				(responseData.singles +
					responseData.doubles +
					responseData.triples +
					responseData.homeruns +
					responseData.walks +
					responseData.hbp) /
				(responseData.atBats + responseData.walks + responseData.hbp + responseData.sf)
			)
				.toFixed(3)
				.substring(1),
			ip: responseData.ip,
			hits: responseData.hits,
			runs: responseData.runs,
			er: responseData.er,
			bb: responseData.bb,
			k: responseData.k,
			hr: responseData.hr,
			era: ((responseData.er / responseData.ip) * 9).toFixed(2),
			whip: ((responseData.bb + responseData.hits) / responseData.ip).toFixed(2),
		});
	}
}